import React from 'react';
import { BRAND, stats, testimonials, testimonialsSecond } from '../data/resinContent';
type TestimonialsSectionProps = {
  /** The first appearance carries the statistics strip. */
  variant?: 'primary' | 'compact';
  id?: string;
};
export function TestimonialsSection({
  variant = 'primary',
  id = 'proof'
}: TestimonialsSectionProps) {
  const isPrimary = variant === 'primary';
  const items = isPrimary ? testimonials : testimonialsSecond;
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby={`${id}-title`} data-id="element-315" data-mp="1d3xnyutb2z75">
      <div className="mx-auto max-w-6xl px-5" data-id="element-316" data-mp="1i28uowob0tl5">
        {isPrimary ? <h2 id={`${id}-title`} className="sr-only" data-id="element-317" data-mp="142hnbesambg4">
            What makers say about {BRAND}
          </h2> : <h2 id={`${id}-title`} className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-318" data-mp="1831i4bpe92z3">
            What makers say about {BRAND}
          </h2>}

        {isPrimary && <dl className="grid grid-cols-2 gap-y-8 border-b border-charcoal-600 pb-10 sm:grid-cols-4" data-id="element-319" data-mp="2uzzvou5egivs">
            {stats.map(s => <div key={s.label} className="flex flex-col-reverse text-center" data-id="element-320" data-mp="34re2lmzokkyy">
                <dt className="mx-auto mt-1.5 max-w-[9rem] text-[10px] font-semibold uppercase tracking-[0.16em] text-ivory-300 sm:text-[11px]" data-id="element-321" data-mp="34tgphy5jdxzg">
                  {s.label}
                </dt>
                <dd className="font-display text-5xl font-semibold leading-none text-champagne sm:text-6xl" data-id="element-322" data-mp="2c2ymsy8q5ymk">
                  {s.value}
                </dd>
              </div>)}
          </dl>}

        <ul className={`grid gap-3 sm:grid-cols-3 ${isPrimary ? 'mt-10' : 'mt-8'}`} data-id="element-323" data-mp="2lyjmuqu8goto">
          {items.map(t => <li key={t.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800 p-5" data-id="element-324" data-mp="1af262bxmjyb">
              <div className="flex items-center gap-3" data-id="element-325" data-mp="3sh8bjtgvppdx">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-[11px] font-semibold tracking-[0.08em] text-champagne" aria-hidden="true" data-id="element-326" data-mp="3sgoxwoy9hn5p">
                  {t.initials}
                </span>
                <span className="text-[11px] tracking-[0.2em] text-champagne" aria-label="5 out of 5 stars" data-id="element-327" data-mp="davherst8e4j">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-3.5 text-[14px] leading-relaxed text-ivory-100" data-id="element-328" data-mp="3gv8agszf79zf">“{t.quote}”</blockquote>
              <footer className="mt-auto pt-4 text-[9.5px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-329" data-mp="3lt1epgh5xtx2">
                {t.name}
                <span className="ml-2 text-ivory-300" data-id="element-330" data-mp="3vib9j43e5qov">{t.role}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}